module.exports = __webpack_public_path__ + "static/subset-UniNeueRegular-3256cc12835290ec8feec58c9c580cf8.woff";